import React from "react";
import moment from "moment";
import { func, shape, string } from "prop-types";

import * as schedulerUtils from "util/scheduler";
import * as i18nUtils from "util/i18n";
import {
    Box,
    DateFieldV3,
    Radio,
    RadioGroup,
    SelectFieldV3,
    Text,
    transfersTestIds,
} from "@ui-kit/components/index.es";

const STARTS_ON_DATE = moment(new Date()).add(1, "days");

function LapseSubOptionV3(props) {
    LapseSubOptionV3.propTypes = {
        frequency: string.isRequired,
        values: shape({}).isRequired,
        onChange: func.isRequired,
    };

    const { frequency, values, onChange } = props;

    const countOptions = Array.from({ length: 42 }, (_, index) => ({
        value: index + 1,
        label: `${index + 1}`,
    }));

    const handleOnChange = (id, data) => {
        let newValue = null;
        if (id === schedulerUtils.NEVER) {
            newValue = { ...values, lapse: id };
        } else if (id === schedulerUtils.UNTIL) {
            newValue = { ...values, date: data || STARTS_ON_DATE.toDate(), lapse: id };
        } else if (id === schedulerUtils.UP_TO) {
            newValue = { ...values, lapse: id, number: data || 1 };
        }
        onChange(newValue);
    };

    const { lapse, number, date } = values;

    const lapseValue =
        frequency === schedulerUtils.YEAR && lapse === schedulerUtils.UNTIL ? schedulerUtils.NEVER : lapse;

    const selectedCountOption = countOptions[number >= 1 ? number - 1 : 0];

    const endDateField = {
        name: "endDate",
        value: date || STARTS_ON_DATE.toDate(),
        onChange: () => {},
        onBlur: () => {},
    };
    const endDateForm = {
        setFieldValue: (_, newDate) => handleOnChange(schedulerUtils.UNTIL, newDate),
        errors: {},
        touched: {},
        submitCount: 0,
    };

    const countField = {
        name: "lapseNumber",
        value: selectedCountOption,
        onChange: () => {},
        onBlur: () => {},
    };
    const countForm = {
        setFieldValue: (_, option) => handleOnChange(schedulerUtils.UP_TO, option?.value ?? option),
        errors: {},
        touched: {},
        submitCount: 0,
    };

    return (
        <Box mt={24} w="100%">
            <Text variant="bodyStrong">{i18nUtils.get("scheduler.ends")}</Text>
            <Box mt={24} w="100%">
                <RadioGroup
                    value={lapseValue}
                    onChange={({ target }) => handleOnChange(target.value)}
                    css={{ "& > div": { gap: "12px" } }}>
                    <Radio
                        id={schedulerUtils.NEVER}
                        data-testid={transfersTestIds.scheduler.lapseNever}
                        value={schedulerUtils.NEVER}
                        label={i18nUtils.get("scheduler.never")}
                    />
                    {frequency !== schedulerUtils.YEAR && (
                        <Box column gap={8}>
                            <Radio
                                id={schedulerUtils.UNTIL}
                                data-testid={transfersTestIds.scheduler.lapseUntil}
                                value={schedulerUtils.UNTIL}
                                label={i18nUtils.get("scheduler.on")}
                            />
                            {lapseValue === schedulerUtils.UNTIL ? (
                                <Box w="100%">
                                    <DateFieldV3
                                        id="endDate"
                                        data-testid={transfersTestIds.scheduler.endDate}
                                        field={endDateField}
                                        form={endDateForm}
                                        minDate={STARTS_ON_DATE.toDate()}
                                        startDate={STARTS_ON_DATE.toDate()}
                                        formattedDisplay
                                        variant="dark"
                                        onDateChange={(newDate) => handleOnChange(schedulerUtils.UNTIL, newDate)}
                                    />
                                </Box>
                            ) : null}
                        </Box>
                    )}
                    <Box column gap={8}>
                        <Radio
                            id={schedulerUtils.UP_TO}
                            data-testid={transfersTestIds.scheduler.lapseUpTo}
                            value={schedulerUtils.UP_TO}
                            label={i18nUtils.get("scheduler.up_to.a11y")}
                        />
                        {lapseValue === schedulerUtils.UP_TO ? (
                            <Box w="100%">
                                <SelectFieldV3
                                    id="lapseCount"
                                    data-testid={transfersTestIds.scheduler.lapseCount}
                                    field={countField}
                                    form={countForm}
                                    options={countOptions}
                                    variant="dark"
                                    onSelectOption={(optionSelected) =>
                                        handleOnChange(schedulerUtils.UP_TO, optionSelected.value)
                                    }
                                />
                            </Box>
                        ) : null}
                    </Box>
                </RadioGroup>
            </Box>
        </Box>
    );
}

export default LapseSubOptionV3;
